<template>
  <div :class="[showBreadcrumbs ? '' : 'mb-md-5', 'my-4']">
    <small v-if="overline" class="font-weight-bold">
      {{ overline }}
    </small>
    <h2>{{ title }}</h2>
    <hr :class="[showBreadcrumbs ? 'mb-2' : '', 'mt-0']" />
    <back-button
      v-if="showBreadcrumbs"
      :current-page="currentPage"
      :prev-page="prevPage"
      :prev-page-link="prevPageLink"
      link-color="secondary"
    />
  </div>
</template>

<script>
import BackButton from "../atoms/BackButton";

export default {
  name: "TitleBackButton",
  components: { BackButton },
  props: {
    overline: String,
    title: String,
    showBreadcrumbs: Boolean,
    currentPage: String,
    prevPage: String,
    prevPageLink: String | Object,
  },
};
</script>

<style scoped lang="scss">
hr {
  border-color: $color-light;
}
</style>
